// extracted by mini-css-extract-plugin
export default {"plugWrapper":"SearchPlug_plugWrapper__VjL1a","title":"SearchPlug_title__HOV-8","text":"SearchPlug_text__KMk+9"};